import { AppBar, Box, Tabs } from "@mui/material";
import { grey } from "@mui/material/colors";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

export const TabPanel: React.FC<React.PropsWithChildren<TabPanelProps>> = (
  props
) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
     {value === index && <>{children}</>}
    </div>
  );
};

export interface TabBarProps {
  value: number;
  onChange: (event: React.SyntheticEvent<{}>, value: unknown) => void;
  children?: React.ReactNode;
  actions?: React.ReactNode;
}

export const TabBar: React.FC<React.PropsWithChildren<TabBarProps>> = (
  props
) => (
  <AppBar
    position="static"
    sx={{
      paddingLeft: { xs: 2, sm: 6 },
      paddingRight: { xs: 2, sm: 6 },
      // develop's value. Reverses 447569f7's tighten-to-1 so the bar sits at the
      // same height as production.
      paddingTop: 3,
      backgroundColor: grey[100],
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    }}
    elevation={0}
    data-testid="tab-bar"
  >
    <Tabs
      value={props.value}
      onChange={props.onChange}
      aria-label="tabs"
      className="detail-view-tabs"
      sx={{ minWidth: 0, flex: 1 }}
    >
      {props.children}
    </Tabs>
    {props.actions && (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          ml: "auto",
          pl: 2,
          flexShrink: 0,
          height: 40,
          borderBottom: "1px solid #ececec",
        }}
      >
        {props.actions}
      </Box>
    )}
  </AppBar>
);

